import { configureStore } from "@reduxjs/toolkit";
import packagesReducer from "./packages/packagesSlice";
import validationErrorsReducer from "./validationErrors/validationErrorsSlice";
import workflowReducer from "./workflow/workflowSlice";
import buttonsReducer from "./buttons/buttonsSlice";

export const store = configureStore({
  reducer: {
    packages: packagesReducer,
    validationErrors: validationErrorsReducer,
    workflow: workflowReducer,
    buttons: buttonsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
